<template>
  <section class="share" id="shareContainer">
    <h3 class="contributors__title content__title" v-html="content.data.share.header"></h3>
    <div class="text-center">
      <vueper-slides
        autoplay
        fixed-height="30rem"
        class="no-shadow"
        :visible-slides="3"
        :arrows-outside="false"
        :bullets="false"
        :infinite="true"
        :dragging-distance="100"
        :touchable="true"
        :gap="3"
        :disable-arrows-on-edges="true"
        :breakpoints="{ 1200: { visibleSlides: 1, slideMultiple: 1, gap: 0 } }"
      >
        <template #arrow-right>
          <img src="@/assets/images/icons/next.png" />
        </template>
        <template #arrow-left>
          <img src="@/assets/images/icons/prev.png" />
        </template>

        <vueper-slide
          v-for="(slide, i) in slides"
          :key="i"
          :id="slide"
          :div="slide.div"
          :title="slide"
          className="share__slide"
        >
          <template #content>
            <div class=""></div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>
  </section>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";

window.twttr = (function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);

  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };

  return t;
})(document, "script", "twitter-wjs");

export default {
  name: "share",
    inject: ['content'],
  data() {
    return {
      title: "Slider",
      slides: Object.values(this.content.data.share.tweets ?? {}) ,
    };
  },

  methods: {
    userTweets() {
      window.twttr.widgets.load(document.getElementById("shareContainer"));
      this.slides?.map(function(slide) {
        window.twttr.widgets
          .createTweet(slide, document.getElementById(slide), {
            align: "center",
            conversation: "none",
            cards: "hidden",
          });
      });
    },
  },
  created() {
    setTimeout(() => {
      this.userTweets();
    }, 5000);
  },
  components: { VueperSlides, VueperSlide },
};
</script>
